import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import GoalsPage from "./components/goals/GoalsPage";
import InvestmentsTable from "./components/InvestmentsTable";
import TransactionsPage from "./components/transactions/TransactionsPage";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => {
	return (
		<>
			{/* 			<TopBar /> */}

			<Routes>
				<Route
					path="/"
					element={
						<ProtectedRoute>
							<Home />
						</ProtectedRoute>
					}
				/>
				<Route path="/login" element={<Login />} />
				<Route
					path="/goals"
					element={
						<ProtectedRoute>
							<GoalsPage />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/investments"
					element={
						<ProtectedRoute>
							<InvestmentsTable />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/transactions"
					element={
						<ProtectedRoute>
							<TransactionsPage />
						</ProtectedRoute>
					}
				/>
			</Routes>
		</>
	);
};

export default App;
